<template>
  <FormItem class="form-item form-item--paytype" label="收款方式" prop="payType">
    <ul class="payway-list clearfix">
      <li
        class="payway-item"
        :class="{'is-active':value===payway.value}"
        v-for="(payway, index) in payWayList"
        :key="index"
        @click="handlePayWayClick(payway)"
      >
        <img class="payway-item__icon" :src="payway.icon">
        <span class="payway-item__name">{{ payway.text }}</span>
      </li>
    </ul>
    <slot name="bottom"></slot>
  </FormItem>
</template>

<script>
import { FormItem } from 'element-ui';

export default {
  components: {
    FormItem
  },
  props: {
    payWayList: Array,
    value: [String, Number]
  },
  methods: {
    handlePayWayClick (payway) {
      this.$emit('input', payway.value);
      this.$emit('item-click');
    }
  }
};
</script>

<style lang="postcss" scoped>

.form-item {
  padding: 20px 35px 20px;
  background-color: #fff;
}

.payway-item {
  display: table;
  float: left;
  width: 220px;
  height: 52px;
  line-height: 52px;
  margin-right: 40px;
  text-align: center;
  border: 1px solid #f3f3f3;
  cursor: pointer;

  > * {
    display: inline-block;
    vertical-align: middle;
  }

  &__icon {
    margin-right: 6px;
  }

  &.is-active {
    background-color: #fef9eb;
    border-color: #fabe00;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/createOrder/FormPayType.vue